var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _path9, _path10, _path11, _path12, _path13, _line, _rect2, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckPointLogoNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "135px",
    height: "28.309px",
    viewBox: "0 0 135 28.309",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D91572;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:none;}\n\t.st4{fill:url(#SVGID_00000094594669642739457870000011571399262899552931_);}\n\t.st5{fill:url(#SVGID_00000115473669342494825150000015599910095871087802_);}\n\t.st6{fill:#EBCDD7;enable-background:new    ;}\n\t.st7{fill:url(#SVGID_00000086688966686591115250000010611912698794089101_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.629,16.36v-0.03c-0.042-2.701,2.114-4.925,4.815-4.967c0.072-0.001,0.144-0.001,0.216,0.001 c1.421-0.068,2.804,0.477,3.796,1.497l-1.35,1.551c-0.645-0.673-1.528-1.065-2.459-1.093c-1.575,0.028-2.83,1.327-2.802,2.902 c0.001,0.03,0.001,0.059,0.003,0.089v0.028c-0.095,1.577,1.106,2.933,2.683,3.028c0.034,0.002,0.068,0.003,0.102,0.004 c0.963-0.007,1.88-0.414,2.531-1.123l1.345,1.365c-0.985,1.146-2.442,1.776-3.952,1.708c-2.682,0.037-4.887-2.107-4.924-4.79 c-0.001-0.058-0.001-0.116,0.001-0.173"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.212,11.546l2.118,0.006l-0.01,3.809l3.907,0.01l0.01-3.809l2.12,0.001l-0.025,9.627l-2.118-0.006 l0.01-3.864l-3.906-0.01l-0.01,3.864l-2.118-0.006L41.212,11.546z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.921,11.574l7.261,0.019l-0.005,1.885l-5.155-0.014l-0.005,1.952l4.538,0.012l-0.005,1.883 l-4.538-0.012l-0.005,2.021l5.228,0.014l-0.005,1.884l-7.328-0.02L51.921,11.574z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.695,16.438v-0.027c-0.041-2.702,2.115-4.926,4.817-4.967c0.071-0.001,0.142-0.001,0.214,0.001 c1.419-0.067,2.8,0.477,3.792,1.494l-1.351,1.552c-0.645-0.673-1.528-1.066-2.46-1.094c-1.575,0.028-2.829,1.326-2.802,2.901 c0.001,0.03,0.002,0.06,0.003,0.09v0.028c-0.095,1.577,1.106,2.933,2.683,3.028c0.033,0.002,0.067,0.003,0.1,0.004 c0.964-0.007,1.881-0.414,2.534-1.123l1.344,1.365c-0.983,1.145-2.438,1.774-3.946,1.708c-2.683,0.037-4.887-2.109-4.924-4.792 c-0.001-0.057-0.001-0.114,0.001-0.171"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.159,11.624l2.119,0.006l-0.011,4.208l3.915-4.198l2.559,0.006l-3.932,4.074l4.087,5.554l-2.545-0.007 l-2.973-4.107l-1.118,1.152l-0.007,2.943l-2.119-0.006L71.159,11.624z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.601,11.66l3.93,0.01c2.296,0.006,3.682,1.371,3.677,3.338v0.024 c-0.006,2.228-1.74,3.379-3.901,3.373h-1.608l-0.007,2.888l-2.116-0.006L84.601,11.66z M88.382,16.524 c0.816,0.104,1.562-0.474,1.665-1.29c0.007-0.054,0.011-0.108,0.012-0.163v-0.028c0-0.948-0.656-1.459-1.713-1.462h-1.637 l-0.007,2.943H88.382z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.58,16.523v-0.027c0.079-2.825,2.433-5.052,5.258-4.973 c2.715,0.075,4.898,2.259,4.973,4.973v0.028c-0.079,2.825-2.433,5.052-5.258,4.973C95.838,21.422,93.655,19.239,93.58,16.523  M101.598,16.544v-0.027c0.059-1.615-1.202-2.973-2.817-3.032c-0.03-0.001-0.061-0.002-0.091-0.002 c-1.591-0.01-2.888,1.272-2.898,2.862c0,0.043,0,0.086,0.002,0.128v0.031c-0.059,1.614,1.201,2.971,2.815,3.03 c0.031,0.001,0.061,0.002,0.092,0.002c1.59,0.01,2.888-1.27,2.898-2.86c0-0.043,0-0.087-0.002-0.13"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 102.118,
    y: 15.472,
    transform: "matrix(0.003 -1 1 0.003 90.0803 123.4115)",
    className: "st0",
    width: 9.627,
    height: 2.116
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.662,11.726l1.953,0.005l4.495,5.937l0.016-5.926l2.089,0.005l-0.025,9.627l-1.8-0.005 l-4.647-6.132l-0.016,6.116l-2.089-0.006L110.662,11.726z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.013,13.715l-2.929-0.007l0.005-1.953l7.976,0.021l-0.005,1.953l-2.926-0.007l-0.02,7.674 l-2.122-0.006L124.013,13.715z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.512,13.998h-0.393v-1.856h-0.703V11.78h1.797v0.361h-0.703L131.512,13.998z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.911,13.459h-0.013l-0.692-1.04v1.582h-0.386v-2.216h0.416l0.672,1.05l0.677-1.047H135 v2.216h-0.386v-1.589L133.911,13.459z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 11.6656,
    cy: 16.6424,
    r: 11.6663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C40047"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    style: {
      stopColor: "#FF0070"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF0070"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,16.61c-0.018,6.443,5.189,11.681,11.632,11.699s11.681-5.189,11.699-11.632 c0.003-0.923-0.104-1.843-0.319-2.741c-1.251,0.578-2.703,0.518-3.901-0.162l-3.437,4.562c1.035,1.204,0.898,3.02-0.307,4.055 s-3.02,0.898-4.055-0.307c-0.771-0.897-0.914-2.174-0.36-3.22l-2.765-2.081l-0.859,1.141l-3.169-2.383l2.382-3.165l3.165,2.382 L8.848,15.9l2.798,2.105c0.886-0.74,2.129-0.879,3.157-0.354l3.423-4.544c-1.687-1.639-1.726-4.335-0.087-6.022 c0.029-0.03,0.058-0.059,0.087-0.087c-1.926-1.316-4.204-2.021-6.537-2.023h-0.032C5.229,4.98,0.017,10.183,0,16.61"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.232,7L18.232,7L18.232,7L18.232,7"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_1709",
    className: "st3",
    x1: 23.013,
    y1: 13.936,
    x2: 23.013,
    y2: 13.936
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004533852021568578100000012114572099587943063_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.4823,
    y1: 21.8485,
    x2: 22.4465,
    y2: 21.8485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7BAC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    style: {
      stopColor: "#ED6493",
      stopOpacity: 0.289
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9017,
    style: {
      stopColor: "#C02852",
      stopOpacity: 0.9017
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B81E47"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004533852021568578100000012114572099587943063_)"
    },
    d: "M16.365,20.105 c0.062,1.586-1.173,2.922-2.758,2.984c-1.144,0.045-2.205-0.593-2.702-1.624c-6.147-0.423-10.346-7.518-10.423-4.817 C0.467,22.714,5.371,27.644,11.436,27.66c6.065,0.016,10.995-4.888,11.011-10.953C22.451,14.705,20.091,18.068,16.365,20.105"
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.479,
    y: 16.037,
    className: "st3",
    width: 21.967,
    height: 11.508
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.909,7.107c-1.512,1.881-4.262,2.181-6.144,0.67s-2.181-4.262-0.67-6.144s4.262-2.181,6.144-0.67 c0.001,0.001,0.003,0.002,0.004,0.003C30.121,2.479,30.42,5.227,28.909,7.107"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143613328426342763810000006369167877952828550_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.9559,
    y1: 8.4755,
    x2: 18.527,
    y2: 11.3974
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7BAC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    style: {
      stopColor: "#FF7DAD",
      stopOpacity: 0.468
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    style: {
      stopColor: "#FD84B1",
      stopOpacity: 0.6367
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7568,
    style: {
      stopColor: "#FA8FB7",
      stopOpacity: 0.7568
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8539,
    style: {
      stopColor: "#F6A0C0",
      stopOpacity: 0.8539
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9361,
    style: {
      stopColor: "#F1B6CB",
      stopOpacity: 0.9361
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBCDD7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143613328426342763810000006369167877952828550_)"
    },
    d: "M10.285,5.852 C7.623,6.245,5.184,7.56,3.393,9.568c-0.936,0.98-1.689,2.119-2.223,3.365c9.951-6.08,11.954-0.114,16.202,1.306l0.853-1.131 c-1.4-1.369-1.691-3.514-0.705-5.206c0.06-0.099,0.129-0.197,0.197-0.288c-1.785-1.199-3.882-1.847-6.032-1.863 c-0.467-0.002-0.934,0.031-1.396,0.099"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M18.56,14.505c0.744,0.069,1.494,0.002,2.214-0.197c-0.585-0.06-1.152-0.242-1.663-0.533L18.56,14.505z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073715999413991170740000016221339485790817459_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.9974,
    y1: 7.8481,
    x2: 17.2277,
    y2: 23.6154
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE6FF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1005,
    style: {
      stopColor: "#FFCDEC",
      stopOpacity: 0.8096
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    style: {
      stopColor: "#FFB0D5",
      stopOpacity: 0.6763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4056,
    style: {
      stopColor: "#FF98C3",
      stopOpacity: 0.535
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5733,
    style: {
      stopColor: "#FF88B6",
      stopOpacity: 0.384
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7594,
    style: {
      stopColor: "#FF7EAE",
      stopOpacity: 0.2166
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7BAC",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073715999413991170740000016221339485790817459_)"
    },
    d: "M0,16.612 c-0.017,6.443,5.192,11.679,11.635,11.696c0,0,0,0,0,0l0.296-5.677c-1.252-0.811-1.678-2.444-0.982-3.763l-2.762-2.082 l-0.859,1.141l-3.169-2.383l2.382-3.165l3.165,2.382l-0.858,1.141l2.798,2.105c0.886-0.74,2.129-0.879,3.157-0.354l3.423-4.544 c-1.687-1.639-1.726-4.335-0.087-6.022c0.029-0.03,0.058-0.059,0.087-0.087c-1.926-1.316-4.204-2.021-6.537-2.023h-0.032 C5.229,4.982,0.017,10.185,0,16.612"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPointLogoNew);
export default __webpack_public_path__ + "static/media/check-point-logo-new.7b3d56e0b0c4e85642f6aedc4b80afb8.svg";
export { ForwardRef as ReactComponent };